import { SyntheticEvent } from 'react';
import { ZodSchema } from 'zod';
import { useQueryStateContext } from '../contexts';
import { CompleteQuery } from '../types';
import { useOnValidate, ValidationSuccessPayload, ValidationFailurePayload } from './useOnValidate';

export const useOnSubmit = ({
  schema,
  onSuccessCb,
  onErrorCb,
}: {
  schema: ZodSchema<CompleteQuery>;
  onSuccessCb: (payload: ValidationSuccessPayload) => void;
  onErrorCb: (payload: ValidationFailurePayload) => void;
}) => {
  const { query: editableQuery } = useQueryStateContext();
  const onValidate = useOnValidate({ onErrorCb, onSuccessCb, editableQuery, schema });
  return (e: SyntheticEvent<HTMLFormElement, SubmitEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    onValidate({ submitEvent: e });
  };
};
